var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.541,
    height: 22.054,
    viewBox: "0 0 16.541 22.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profit-report",
    transform: "translate(-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4383",
    "data-name": "Group 4383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M80.487,5.938a.682.682,0,0,0-.149-.223L74.826.2a.7.7,0,0,0-.488-.2h-8.96A1.381,1.381,0,0,0,64,1.378v19.3a1.381,1.381,0,0,0,1.378,1.378H79.162a1.381,1.381,0,0,0,1.378-1.378V6.2A.688.688,0,0,0,80.487,5.938Zm-5.46-3.585,3.161,3.161H75.027Zm4.135,18.323H65.378V1.378h8.27V5.514a1.381,1.381,0,0,0,1.378,1.378h4.135Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(68.135 13.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M160.689,320a.689.689,0,0,0-.689.689v4.135a.689.689,0,1,0,1.378,0v-4.135A.689.689,0,0,0,160.689,320Z",
    transform: "translate(-160 -320)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(75.027 8.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M320.689,192a.689.689,0,0,0-.689.689v9.649a.689.689,0,1,0,1.378,0v-9.649A.689.689,0,0,0,320.689,192Z",
    transform: "translate(-320 -192)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(71.581 11.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M240.689,256a.689.689,0,0,0-.689.689v6.892a.689.689,0,1,0,1.378,0v-6.892A.689.689,0,0,0,240.689,256Z",
    transform: "translate(-240 -256)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.e0968ec8a2f1884dc9f2d31adfbf8dbf.svg";
export { ForwardRef as ReactComponent };